import React from "react";
import { Grid, Typography, Box, Chip } from "@mui/material";
import styles from "../index.module.css";

const LOGO = "https://elitepromomarketing.com/wp-content/uploads/2024/08/logo-1-600x183.png";

export default function ProofHeader({
  title = "Proof Review",
  meta = [],
  rightChips = [],
}) {
  const metaLines = (Array.isArray(meta) ? meta : []).filter(Boolean);

  return (
    <Grid container className={styles.headerContainer}>
      {/* Logo */}
      <Grid item className={styles.headerLogoContainer}>
        <img src={LOGO} className={styles.headerLogo} alt="Logo" />
      </Grid>

      {/* Title + meta */}
      <Grid item className={styles.TitleContainer}>
        <Box sx={{ width: "100%" }}>
          <Typography variant="h4" gutterBottom color="white">
            {title}
          </Typography>

          {metaLines.length > 0 && (
            <Typography variant="body1" color="white">
              {metaLines.map((line, i) => (
                <span key={i}>
                  {line}
                  {i < metaLines.length - 1 && <><br /></>}
                </span>
              ))}
            </Typography>
          )}
        </Box>
      </Grid>
      {/* Right-side chips */}
      <Grid item className={`${styles.rightBar} ${styles.rightAbsolute}`}>
        <Box className={styles.rightBarInner}>
          {rightChips.map((chip, idx) => (
            <Chip key={idx} size="small" label={chip} variant="outlined" />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}
